<!--
 * @Author: Tina Huang
 * @Date: 2022-09-26 00:45:18
 * @LastEditors: Tina Huang
 * @LastEditTime: 2022-10-17 13:17:18
 * @Description: 
-->
<template>
  <div class="lib-container">
    <el-row>
      <el-col :span="12">
        <div class="basic">
          <h2>Formula 基本概念和函数</h2>
          <p>在使用Formula功能前需要先了解一些基本概念和基本公式</p>
          <ul>
            <li>
              <h3>Property（属性，在表格内每一列都是一个属性）</h3>
              在公式内<code>prop("属性")</code>是返回每个记录内对应的属性值，且带有对应的数据格式
            </li>
            <li>
              <h3>公式内的四种数据类型（也是可返回的数据类型）</h3>
              <ul>
                <li>
                  字符串（文本）：标题，text，select等返回的数据格式都是字符串
                </li>
                <li>数字</li>
                <li>日期</li>
                <li>布尔值（true or false）：即结果呈现为单选是否被选中</li>
              </ul>
            </li>
            <li>
              <h3>基本函数</h3>
              <ul>
                <li>
                  <strong>if语法</strong
                  >，在公式中有两种运算语法，其中boolean指的是条件，第一个value是符合条件的结果，第二个value指的是非对应的结果
                  <pre>boolean ? value : value<br>if(boolean, value, value)</pre>
                  例如：当前有一个属性为「成绩」，需要判断成绩状态<br />
                  <pre>prop("成绩") >= 60 ? "及格" : "不及格"<br>if(prop("成绩") >= 60, "及格" , "不及格")
                        </pre>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="list">
          <h2>Notion内使用主要公式</h2>
          <el-row>
            <el-col :span="12">
              <el-select v-model="type" placeholder="请选择">
                <el-option key="所有" label="所有" value="所有"> </el-option>
                <el-option key="日期" label="日期" value="日期"> </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-input
                placeholder="搜索公式"
                prefix-icon="el-icon-search"
                v-model="keywords"
              >
              </el-input>
            </el-col>
          </el-row>
          <card-item
            v-for="(item, index) in list"
            :key="item.title"
            mode="compact"
          >
            <h3>
              <span
                >NO.{{ index + 1 }} 「{{ item.title }}」<el-tag
                  type="success"
                  size="small"
                  >{{ item.type }}</el-tag
                ></span
              ><i class="el-icon-view" @click="showDetail"></i>
            </h3>
            <el-collapse-transition>
              <div class="item-detail" v-show="show_detail">
                <p>
                  需要的属性（列）：<el-tag
                    type="primary"
                    v-for="prop in item.properties"
                    :key="prop.label"
                    effect="dark"
                    >{{ prop.label }}({{ prop.type }})</el-tag
                  >
                </p>
                <template v-if="item.code">
                  <strong>常规公式</strong>
                  <pre>{{ item.code }}</pre>
                </template>
                <template v-if="item.text_code">
                  <strong
                    >文案公式（增加逻辑判断展示可读性文案，可<span>复制</span>该部分公式）</strong
                  >
                  <code>{{ item.text_code }}</code>
                </template>
              </div>
            </el-collapse-transition>
          </card-item>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CardItem from "../components/comp/card-item.vue";
export default {
  components: { CardItem },
  data() {
    return {
      list: [
        {
          title: "倒数日",
          properties: [{ label: "目标日", type: "Date" }],
          code: 'dateBetween(now(), prop("目标日"), "days")',
          text_code:
            '(dateBetween(now(), prop("目标日"), "days") == 0) ? "🎉 就是今天" : (dateBetween(now(), prop("目标日"), "days") < 0) ? ("⏰ 还有" + format(abs(dateBetween(now(), prop("目标日"), "days")))+"天") : ("✅ 过去" + format(dateBetween(now(), prop("目标日"), "days")))+"天")',
          type: "日期",
        },
      ],
      keywords: "",
      type: "所有",
      show_detail: false,
    };
  },
  methods: {
    showDetail() {
      this.show_detail = !this.show_detail;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../less/var.less";
.lib-container {
  padding: 5vw;
  padding-top: 20px;
  min-height: 70vh;
  //   display: flex;
  //   justify-content: space-between;
  h2 {
    font-size: 0.6rem;
    text-align: center;
  }
  h3 {
    font-size: 0.35rem;
  }
  p,
  li,
  strong {
    font-size: 0.3rem;
    margin: 0;
  }
}
.list {
  padding-left: 5vw;
  h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    i {
      cursor: pointer;
    }
  }
}
pre {
  word-break: break-word;
  word-wrap: wrap;
}
.list code {
  display: block;
  padding: 5px 0;
}
.list strong span {
  color: @focus-color;
}
h3 span {
  // color: @second-color;
}
.item-detail {
  // display: none;
}
</style>
